import { render, staticRenderFns } from "./ManageStageControl.vue?vue&type=template&id=07b0043f"
import script from "./ManageStageControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageStageControl.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports